import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { orderStatusApi } from '../../../../../services/requests';
import * as TP from '../../../../../types/apiResponseTypes';

type Props = {
  closeModal: () => void;
  reqGetAllOrderStatuses: () => void;
  orderStatusSelected: TP.OrderStatus;
};

const DeleteOrderStatus = ({ closeModal, reqGetAllOrderStatuses, orderStatusSelected }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const reqDeleteOrderStatus = async () => {
    setIsLoading(true);

    const source = orderStatusApi.axios.CancelToken.source();

    try {
      const res = await orderStatusApi.delete(orderStatusSelected.id);

      if (res.status === HttpStatus.OK) {
        setIsLoading(false);
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        closeModal();
        reqGetAllOrderStatuses();
      } else {
        throw res;
      }

      setIsLoading(false);
    } catch (err) {
      if (!orderStatusApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
      setIsLoading(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('deleteOrderStatus')}
      showModal
      closeModal={closeModal}
      action={() => reqDeleteOrderStatus()}
      actionNameBtn={t('delete')}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <p>
              {`${t('deleteSure')}?`}
              <br />
              <br />
              <b>{t('key')}:</b> {orderStatusSelected.key}
              <br />
              <b>{t('description')}:</b> {orderStatusSelected.description}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteOrderStatus;
